import { Component, OnInit,ViewChild } from '@angular/core';
import { CustomerService } from 'app/shared/services/customer.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';




@Component({
  selector: 'app-view-customers',
  templateUrl: './view-customers.component.html',
  styleUrls: ['./view-customers.component.css']
})
export class ViewCustomersComponent implements OnInit {

  displayedColumns: string[] = ['CusId', 'CusName', 'Phone', 'Email','Status','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  
  isDark: boolean = false;

  dataList:any;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 
  

  constructor(private customerService : CustomerService,
              private router : Router, 
              private route : ActivatedRoute,
              private toastr: ToastrService,
              private themeService: NbThemeService,
              private authService: AuthService,
              private dialogService: DialogService,) { }

  ngOnInit() {

    this.getAllCustomers();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='CM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  getAllCustomers(){
    this.customerService.getAll()
     .subscribe(
        (data) => {
                  this.dataList = data;
                  this.dataSource = new  MatTableDataSource (this.dataList);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }
   
     newCustomerButtonClick(){ 
      this.customerService.dataRow = null;
      this.router.navigate(['../customer'],{relativeTo : this.route});
     }

     gerRowData(row){   
       this.customerService.dataRow = row;  
       this.router.navigate(['../customer'],{relativeTo : this.route});
     
   }

     deleteButtonClick(cusId : string){

      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.customerService.deleteCustomer(cusId)
        .subscribe(
          (res) => {
                      this.toastr.success('Record deleted successfully','Success');
                      this.getAllCustomers();
                      console.log(res);     
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
   }

   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }


} //end class
